module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero__container"
  }, [_vm._l((_vm.props.images), function(slide, i) {
    return _c('div', {
      staticClass: "hero__bg",
      class: {
        'hero__bg--active': i === _vm.currSlide, 'hero__bg--large': _vm.switchSize % 2 === 0
      },
      style: ({
        backgroundImage: 'url(' + slide.image + ')'
      })
    })
  }), _c('div', {
    staticClass: "hero__text",
    class: {
      'hero__text--slide': _vm.slide, 'hero__text--alt': _vm.currSlide === 2
    },
    domProps: {
      "innerHTML": _vm._s(("<h1>" + (_vm.props.text) + "</h1>"))
    }
  }), _vm._l((_vm.props.images), function(patient, i) {
    return _c('h3', {
      key: "patient - " + i,
      staticClass: "hero__patient-name",
      class: {
        'hero__patient-name--showing': i === _vm.currSlide
      },
      domProps: {
        "innerHTML": _vm._s(patient.patient)
      }
    })
  }), _c('div', {
    staticClass: "hero__invisalign"
  }, [_c('Icon', {
    attrs: {
      "name": "invisalign-top"
    }
  })], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92e12bf4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero.pug
// module id = 662
// module chunks = 1